module.exports = __webpack_public_path__ + "static/media/Done-5.1b08c001.png";